import { axios, BaseApiUrl } from '../axios_config';


// 获取移动端待出库列表
export const getList = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/GetArriveList`, { ...params }).then(res => res.data)
}


